import { createFileRoute } from '@tanstack/react-router';

import { PageContainer } from '../components/layout/page-container';
import { ArticleList } from '../features/articles/article-list';
import { articlesQuery } from '../features/articles/use-articles';
import { awaitOnServer } from '../lib/await-on-server';
import { pageHead } from '../lib/seo';
import { canonical } from '../lib/site';

/**
 * 좋소 PD 수첩 blog list (V4 §C). The loader fills the first page on the server
 * (useInfiniteQuery, infinite scroll). An optional `?tag=` narrows the feed and is shareable.
 */
const PD_DESCRIPTION =
  '우리 주변의 좋소 문제를 취재하고 환기하는 블로그형 시사 코너. 비방이 아니라 더 나은 일터를 위한 기록.';

export const Route = createFileRoute('/articles/')({
  validateSearch: (search): { tag?: string } => {
    const raw = search.tag;
    return typeof raw === 'string' && raw.trim() !== '' ? { tag: raw } : {};
  },
  loaderDeps: ({ search: { tag } }) => ({ tag }),
  loader: ({ context: { queryClient }, deps: { tag } }) =>
    awaitOnServer(queryClient.ensureInfiniteQueryData(articlesQuery(tag))),
  head: () =>
    pageHead({
      title: '아티클',
      description: PD_DESCRIPTION,
      url: canonical('/articles'),
      type: 'website',
      feed: { url: canonical('/articles/rss.xml'), title: '아티클 RSS' },
    }),
  component: PdListPage,
});

function PdListPage() {
  const { tag } = Route.useSearch();
  return (
    <PageContainer>
      <ArticleList tag={tag} />
    </PageContainer>
  );
}
